import { render, staticRenderFns } from "./PdfBook.vue?vue&type=template&id=32683215&"
import script from "./PdfBook.vue?vue&type=script&lang=js&"
export * from "./PdfBook.vue?vue&type=script&lang=js&"
import style0 from "./PdfBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default,Confetti: require('/home/circleci/repo/components/Confetti.vue').default})
